import styled from 'styled-components';
import { Button } from 'reactstrap';
import { color } from '~/assets/styles/colors';

export const TextError = styled.div`
	color: #c53030;
`;

export const ButtonStyled = styled(Button)`
	background-color: ${({ disabled }) =>
		!disabled ? '#dbdbdb' : color.primary} !important;
	border-radius: 0 !important;
	border: 0 !important;
	color: ${({ disabled }) =>
		!disabled ? color.gray : color.black} !important;
	opacity: 1 !important;

	&:hover {
		background-color: ${color.primary} !important;
		opacity: 0.6 !important;
	}
`;
